module.exports = __webpack_public_path__ + "assets/img/huoCar.b3c156ca.png";